module.exports = __webpack_public_path__ + "img/02车窗防夹控制器软件著作权.88c15e56.png";